import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import deepMerge from '../utils/mergeDeep';
import { theme } from './theme';
export const ThemeProvider = ({ children, overrideTheme }) => (_jsx(MuiThemeProvider, Object.assign({ theme: overrideTheme ? deepMerge(theme, overrideTheme) : theme }, { children: children })));
